/* tslint:disable */
import {
  Game,
  Language,
  Translation
} from '../index';

declare var Object: any;
export interface AdminInterface {
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "id"?: any;
  "password"?: string;
  games?: Game[];
  accessTokens?: any[];
  languages?: Language[];
  translations?: Translation[];
}

export class Admin implements AdminInterface {
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "id": any;
  "password": string;
  games: Game[];
  accessTokens: any[];
  languages: Language[];
  translations: Translation[];
  constructor(data?: AdminInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Admin`.
   */
  public static getModelName() {
    return "Admin";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Admin for dynamic purposes.
  **/
  public static factory(data: AdminInterface): Admin{
    return new Admin(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Admin',
      plural: 'admins',
      path: 'admins',
      idName: 'id',
      properties: {
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        games: {
          name: 'games',
          type: 'Game[]',
          model: 'Game',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'adminId'
        },
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        languages: {
          name: 'languages',
          type: 'Language[]',
          model: 'Language',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'adminId'
        },
        translations: {
          name: 'translations',
          type: 'Translation[]',
          model: 'Translation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'adminId'
        },
      }
    }
  }
}
